import { type Guard, type GuardStatus, useSettings } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { useNonCustodialProviderUserWalletStatus } from '@socios-blk/core';

export const useHasNCWalletSettingsGuard: Guard = () => {
	const { replace } = useRouter();
	const {
		areSettingsLoading,
		settings: { isPoblanoEnabled }
	} = useSettings();

	const { isLoading: isNCWStatusLoading, isNCWalletRegistered } = useNonCustodialProviderUserWalletStatus();

	let status: GuardStatus = 'denied';

	if (areSettingsLoading || isNCWStatusLoading) {
		status = 'loading';
	} else if (isPoblanoEnabled && isNCWalletRegistered) {
		status = 'allowed';
	}

	return {
		onDenied: () => replace('/settings'),
		status
	};
};
